import {AbstractCommand} from "./abstract.command";
import {CommandName} from "./command-name.enum";
import {LOCKABLE_ENTITY_TYPE_LINKVIEW} from "./lockable-entity-type.constant";

/**
 * The payload the backend reads: `{ entityType, uid }`.
 *
 * `entityType` names WHICH kind of entity is being locked and is resolved
 * server-side through a hardcoded whitelist — a class name is never built from
 * client input. `uid` is the target entity's own uid, transport spelling.
 */
export interface LockEntityPayload {
    readonly entityType: string;
    readonly uid: string;
}

/**
 * Takes the edit lock on an entity.
 *
 * Sent ALONE and immediately, never inside a save bulk: a lock takes effect when
 * the user enters edit mode, not when they save, and it carries its own
 * permission string.
 */
export class LockEntityCommand extends AbstractCommand<LockEntityPayload> {

    public name = CommandName.LOCK_ENTITY;

    public tags: string[] = [`entity`, `lock`, LOCKABLE_ENTITY_TYPE_LINKVIEW];

    constructor(payload: LockEntityPayload) {
        super(payload.entityType, payload.uid, payload);
    }
}
